const updatePasswordPath = '/auth/change-password';
export default updatePasswordPath;
